// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + {"265":"canvg","297":"xlsx","643":"pdfmake"}[chunkId] + "." + {"265":"c355734f","297":"a686f16b","643":"c1a8ebc1"}[chunkId] + ".chunk.js";
};